import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ver-requisito-becario',
  templateUrl: './ver-requisito-becario.component.html',
  styleUrls: ['./ver-requisito-becario.component.css']
})
export class VerRequisitoBecarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
